<template>
  <div>
    <mu-appbar class="appbar">
      <mu-button icon slot="left" @click="open = !open">
        <mu-icon value="menu"></mu-icon>
      </mu-button>
      <div style="font-size: 18px; text-align: center; font-weight: 500;">EILIS 社群數位會員卡</div>
      <!-- <mu-avatar :size="50" style="position: absolute; right: 70px; top: 7px;">
        <img :src="avatarImg" class="profilePhoto" @click="photoDia = true">
      </mu-avatar> -->
      <mu-icon ref="showButton" value="person" style="position: absolute; right: 60px; top: 22px; cursor: pointer;" :class="{ upside: visible , downside: !visible }"></mu-icon>
      <div class="dropdown__header">
        <div class="box" ref="dropdown" v-if="visible" >
          <!-- <li @click="profile">{{ $t('message.account') }}</li> -->
          <!-- <hr color="#d1d1d1" size="1" width="100%"> -->
          <li @click="openAlertDialog">Logout</li>
        </div>
      </div>
      <!-- <mu-button flat slot="right" @click="logout">登出</mu-button> -->
    </mu-appbar>
    <!-- 左側選單 -->
    <mu-drawer :open.sync="open" :docked="docked" :right="position === 'right'">
      <mu-list>
        <mu-list-item button v-for="(item, index) in menu" :key="index" @click="getVal(item.url)">
          <mu-list-item-title class="item">{{item.title}}</mu-list-item-title>
        </mu-list-item>
      </mu-list>
    </mu-drawer>
    <!-- 設定大頭貼 -->
    <mu-dialog title="設定大頭貼" width="500" :open.sync="photoDia">
      <div style="text-align: center;">
        <mu-avatar :size="150">
          <img :src="avatarImg"/>
        </mu-avatar><br><br>
        <label class="upload">
          上傳圖片
          <input type="file" name="myFile" id="myFile" @change="onFileSelected"/>
        </label>
      </div>
      <mu-button slot="actions" color="#67c23a" @click="uploadPhoto">送出修改</mu-button>
    </mu-dialog>
    <mu-dialog title="上傳中..." :open="uploading">
      <mu-linear-progress style="width: 300px"/>
    </mu-dialog>
    <!-- 設定大頭貼 -->
    <router-view id="main"></router-view>
    <mu-dialog :open="openAlert" title="系統通知" @close="openAlert = false" width="40%">
      <div>確定要登出嗎?</div>
      <mu-button slot="actions" round color="success" @click="logout">確定</mu-button>
    </mu-dialog>
    <!-- 電話驗證 -->
    <mu-dialog :open="phoneVerDia" title="系統通知" width="500">
      <div style="margin-bottom: 10px;">為確保帳號安全性，請協助進行電話驗證，感謝您的配合!</div>
      <mu-carousel :active="active" :hide-controls="true" :hide-indicators="true" :cycle="false" style="height: 100px;">
        <mu-carousel-item>
          <el-input placeholder="電話號碼。例:0912345678" v-model="verifyPhone">
            <el-button slot="append" :disabled="count !== 0" @click="sendVer">發送驗證碼 {{ count === 0 ? '' : count }}</el-button>
          </el-input>
        </mu-carousel-item>
        <mu-carousel-item>
          <div style="margin-bottom: 10px;">請輸入驗證碼</div>
          <el-input v-model="verCode" placeholder="請輸入6位數字驗證碼"></el-input>
          <div v-if="errorText" style="color: #f24;">{{ errorText }}</div>
        </mu-carousel-item>
      </mu-carousel>
      <mu-button v-if="active === 1" slot="actions" color="info" :disabled="count !== 0" @click="sendVer">重新發送 {{ count === 0 ? '' : count }}</mu-button>
      <mu-button v-if="active === 1" slot="actions" color="primary" @click="checkCode">確認</mu-button>
    </mu-dialog>
    <!-- 成功 -->
    <mu-dialog :open="successDia" @close="successDia = false">
      <div style="text-align: center; margin-bottom: 10px; color: #0ccc0f">
        <i class="el-icon-circle-check" style="font-size: 40px;"></i>
      </div>
      <div>電話驗證成功！可使用 <b>{{ verifyPhone }}</b> 作為你的登入帳號</div>
    </mu-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  name: 'HelloWorld',
  data() {
    return {
      photoDia: false,
      avatarImg: localStorage.getItem('ProfileImg') ? localStorage.getItem('ProfileImg') : 'https://www.nownews.com/wp-content/uploads/2016/08/1535204662-3f6673bf0c2b69f659169b486f6adc2c.jpg',
      uploading: false,
      open: false,
      docked: false,
      visible: false,
      phoneVerDia: false,
      successDia: false,
      showTitle: '',
      openAlert: false, // 登出dialog
      position: 'left',
      verifyPhone: '',
      errorText: '',
      verCode: '',
      code: '',
      active: 0,
      count: 0,
      selected: {},
      menu: [
        {
          title: '首頁',
          url: '/mainpage',
        },
        {
          title: '聊天機器人',
          url: '/chatbot'
        },
        {
          title: '社群數位會員卡',
          url: '/shoplist'
        }
      ],
    }
  },
  created() {
    document.addEventListener('click', this.documentClick);
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    ...mapActions({
      sendSMS: 'sendSMS',
      setUserPhone: 'setUserPhone'
    }),
    countDown() {
      this.count = 60;
      setInterval(() => {
        if (this.count > 0) {
          this.count -= 1
        }
      }, 1000)
    },
    checkCode() {
      if (this.verCode) {
        if (this.verCode === this.code) {
          const uid = localStorage.getItem('UserID');
          const loading = this.$loading({
            lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
          });
          this.errorText   = '';
          this.phoneVerDia = false;
          this.setUserPhone({ phone: this.verifyPhone, uid: uid }).then(() => {
            loading.close();
            this.successDia  = true;
          })
        }
        else {
          this.errorText = '驗證碼輸入錯誤';
        }
      }
      else {
        this.errorText = '請輸入6位數字驗證碼';
      }
    },
    sendVer() {
      this.countDown();
      const random = new Array('0','1','2','3','4','5','6','7','8','9');
      let code = '';
      for (let e = 0; e < 6; e += 1) {
        const index = Math.floor(Math.random() * 10);
        code += random[index];
      }
      this.code = code;
      this.sendSMS({ phone: this.verifyPhone, code: code }).then(() => {
        this.active = 1;
      })
    },
    openAlertDialog() {
      this.openAlert = true;
    },
    documentClick(e) {
      const el = this.$refs.dropdown;
      const el2 = this.$refs.showButton;
      const target = e.target;
      if (target !== el && target !== el2) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    // 上傳圖片到 DB
    onFileSelected(event) {
      this.uploading = true;
      // 使用者 uid
      const uid = localStorage.getItem('UserID');
      // 檔案
      const file = event.target.files[0];

      const formData = new FormData();
      formData.append('uid', uid);
      formData.append('myfile', file);

      const config = {
        header: {
          "content-type": "multipart/form-data"
        }
      };
      // 上傳表單資料
      this.axios.post('https://firebase-member-node.herokuapp.com/upload', formData, config)
        .then((res) => {
          this.avatarImg = res.data.url;
          setTimeout(() => {
            this.uploading = false;
          }, 1700);
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            this.uploading = false;
          }, 1700);
        });
    },
    toggle (flag) {
      this.open = !this.open;
      this.docked = !flag;
    },
    getVal(url) {
      if (url === '/chatbot') {
        this.showTitle = '聊天機器人';
      }
      else if (url === '/shoplist') {
        this.showTitle = 'EMC 數位會員卡';
      }
      else {
        this.showTitle = '首頁';
      }
      this.$router.push(url);
      this.open = false;
    },
    uploadPhoto() {
      this.photoDia = false;
      const apiUrl = 'https://firebase-member-node.herokuapp.com/users/setPhoto';
      const postData = {
        uid: localStorage.getItem('UserID'),
        imageUrl: this.avatarImg
      };
      this.axios.post(apiUrl, postData).then((res) => {
        console.log(res);
      })
    },
    logout() {
      localStorage.clear();
      window.location.reload();
    },
    // 取得用戶基本資料
    getUserDetail() {
      const loading = this.$loading({
        lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
      });
      const apiUrl = 'https://firebase-member-node.herokuapp.com/users/getUserDetail';
      const postData = {
        uid: localStorage.getItem('UserID')
      };
      this.axios.post(apiUrl, postData)
        .then((res) => {
          loading.close();
          localStorage.setItem('MemberData', JSON.stringify(res.data.detail));
          localStorage.setItem('UserName', res.data.detail.UserName);
          // 尚未驗證過電話
          if (!res.data.detail.Phone) {
            this.phoneVerDia = true;
          }
          // 取得大頭照
          if (res.data.detail && res.data.detail.ProfileImg) {
            localStorage.setItem('ProfileImg', res.data.detail.ProfileImg);
            this.avatarImg = res.data.detail.ProfileImg;
          }
        });
    },
    checkLogin() {
      if (!localStorage.getItem('UserID') || !localStorage.getItem('lastLogin')) {
        this.$router.push('/');
      } 
      else {
        this.getUserDetail();
      }
    },
  },
}
</script>

<style>
.btn {
  position: relative;
  margin-top: -7px;
  margin-left: -10px;
  color: #ffff;
  font-size: 18px;
  height: 70px;
  position:relative; top:-10px;
  background-color: transparent;
  border: solid 0px;
}
.appbar {
  width: 100%;
  position: fixed;
  color:#fff;
  background-color: #444444;
  box-shadow: none;
}
.upside {
  /* -webkit-transform: rotate(180deg);
  transform: rotate(180deg); */
  transition: all 0.4s ease;
}
.downside {
  /* -webkit-transform: rotate(360deg);
  transform: rotate(360deg); */
  transition: all 0.4s ease;
}
.box {
  width: 210px;
  height: 168px;
  position: absolute;
  font-size: 16px;
  right: 0px;
  top: 60px;
  border-radius: 14px;
  background-color: #fff;
  box-shadow: 1px 1px 2px 4px rgba(169, 169, 169, 0.1), 0px 1px 4px 1px rgba(173, 173, 173, 0.6);
  font-weight: 300;
  transition: 1.5s;
  overflow: hidden;
}
.box li {
  color: rgb(152, 20, 81);
  line-height: 25px;
  padding: 9px 21px;
  text-decoration: none;
  display: block;
  cursor: pointer;
}
.box li:hover {
  width: 210px;
  font-weight: 300;
  color: rgba(250, 250, 250, 0.954);
  background-color: #5cba5f;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}
.box li:hover span {
  color: #fff;
}
.item {
  font-weight: 500;
  opacity: 0.5;
}
.mu-item-wrapper:hover {
  background-color: #eee;
}
.mu-item-wrapper:hover .mu-item-title {
  opacity: 1;
}
</style>
